import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=115e1b50&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=115e1b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e1b50",
  null
  
)

export default component.exports